import { __extends } from "tslib";
import { release, warning } from '@awayfl/swf-loader';
import { ASObject } from '@awayfl/avm2';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: ContextMenuClipboardItems
var partialImp = function (obj, field) {
    return warning("[Builtins] Partial implemented " + (obj.name || obj.constructor.name) + "::" + field);
};
var ContextMenuClipboardItems = /** @class */ (function (_super) {
    __extends(ContextMenuClipboardItems, _super);
    function ContextMenuClipboardItems() {
        var _this = _super.call(this) || this;
        _this._cut = true;
        _this._copy = true;
        _this._paste = true;
        _this._clear = true;
        _this._selectAll = true;
        return _this;
    }
    Object.defineProperty(ContextMenuClipboardItems.prototype, "cut", {
        get: function () {
            release || partialImp(this, 'get cut');
            return this._cut;
        },
        set: function (val) {
            release || partialImp(this, 'set cut');
            this._cut = !!val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "copy", {
        get: function () {
            release || partialImp(this, 'get copy');
            return this._copy;
        },
        set: function (val) {
            release || partialImp(this, 'set copy');
            this._copy = !!val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "paste", {
        get: function () {
            release || partialImp(this, 'get paste');
            return this._paste;
        },
        set: function (val) {
            release || partialImp(this, 'set paste');
            this._paste = !!val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "clear", {
        get: function () {
            release || partialImp(this, 'get clear');
            return this._clear;
        },
        set: function (val) {
            release || partialImp(this, 'set clear');
            this._clear = !!val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenuClipboardItems.prototype, "selectAll", {
        get: function () {
            release || partialImp(this, 'get selectAll');
            return this._selectAll;
        },
        set: function (val) {
            release || partialImp(this, 'set selectAll');
            this._selectAll = !!val;
        },
        enumerable: true,
        configurable: true
    });
    ContextMenuClipboardItems.prototype.clone = function () {
        var items = new ContextMenuClipboardItems();
        items._cut = this._cut;
        items._copy = this._copy;
        items._paste = this._paste;
        items._clear = this._clear;
        items._selectAll = this._selectAll;
        return items;
    };
    ContextMenuClipboardItems.classInitializer = null;
    ContextMenuClipboardItems.classSymbols = null; // [];
    ContextMenuClipboardItems.instanceSymbols = null;
    return ContextMenuClipboardItems;
}(ASObject));
export { ContextMenuClipboardItems };
